import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SettingsProvider } from "@/context/SettingsContext";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import Story from "@/pages/Story";
import Schedule from "@/pages/Schedule";
import Travel from "@/pages/Travel";
import DressCode from "@/pages/DressCode";
import Rsvp from "@/pages/Rsvp";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App font-body">
      <SettingsProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/our-story" element={<Story />} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/travel" element={<Travel />} />
              <Route path="/dress-code" element={<DressCode />} />
              <Route path="/rsvp" element={<Rsvp />} />
              <Route path="/admin" element={<Admin />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </SettingsProvider>
    </div>
  );
}

export default App;
